import React, { useState , useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { dashboardAction } from '../../redux/action';
const SeoAdd = (props: any) => {
  const { slug } = props;
  const dispatch = useDispatch();
  const seoData: any = useSelector((state: any) => state.dashboard.seoDetail?.Details);
  const url = `https://malikgabroun.com/${seoData?.Slug}`;

  const canonicalUrl = window.location.href;


  useEffect(() => {
    let Slug = slug && slug?.replace("/", "");
    dispatch(dashboardAction.seoDetailAction({ Slug: Slug ? Slug : 'home' }));
    return () => { }
  }, [])

  if (!seoData?.SeoTitle) {
    return <p>Loading...</p>;
  }
  return (
    <>
      <Helmet
        title={seoData?.SeoTitle + " - Oncquest Labs"}
        meta={[
          {
            name: 'description',
            content: seoData?.SeoDescription,
          },
          {
            name: 'keywords',
            content: seoData?.SeoKeywords,
          },
        ]}
        link = {[
          { 
            rel : 'canonical', 
            href : canonicalUrl }
        ]}
      />
    </>
  )
}

export default React.memo(SeoAdd)
